<button
  type="button"
  [id]="'color-picker-list-button' + color"
  class="shrink-0 cursor-pointer rounded border border-neutral-300"
  [ngClass]="getButtonSize()"
  [style.backgroundColor]="color"
  (click)="$event.stopPropagation(); openState.set(true)" 
  cdkOverlayOrigin 
  #origin="cdkOverlayOrigin"
  ></button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="openState()"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="close()"
  (detach)="close()">
  <div
    style="max-height: 300px; overflow-y: auto;"
    class="bg-primary-on border-standard-outline-light z-50 flex w-full flex-col gap-0.5 rounded-xl border shadow-xl">
    <aw-tabs 
      [width]="'300px'"
      [properties]="[
        {
          name: cmsTextProvider.shared.predefined,
          content: predefined
        },
        {
          name: cmsTextProvider.shared.custom,
          content: custom
        }]"
    >
  </aw-tabs>
  </div>
</ng-template>

<ng-template #predefined>
  @for (c of colorOptions; track c.name) {
    <button
      type="button"
      style="align-items: center"
      class="hover:bg-standard-hover-main flex w-full cursor-pointer gap-3 rounded-lg px-3 py-2 transition-colors"
      [ngClass]="c.primary ? isDarkMode() ? 'border-b border-neutral-800' : 'border-b border-neutral-200' : ''"
      (click)="pick(c.value)">
      <span
        class="size-5 shrink-0 cursor-pointer rounded border border-neutral-300"
        [style.background-color]="'#' + c.value"
        aria-hidden="true"></span>
      <span class="text-standard-text-primary text-sm font-medium">
        {{ c.name }}
      </span>
      @if (c.primary) {
        <span class="material-symbols-rounded cursor-pointer text-xl pt-1 icon-filled ml-auto">
          star
        </span>
      }
    </button>
  }
</ng-template>

<ng-template #custom>
  <div class="p-3">
    <aw-color-picker
      [inline]="true"
      [value]="color"
      (valueChange)="pick($event)"
      (closed)="''" />
  </div>
</ng-template>